"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var yotpo_review_1 = require("../../utils/shopify-graphql/yotpo-review");
var Loading_1 = require("../common/Loading");
var YotpoBottomline_1 = require("./YotpoBottomline");
var YotpoReviewMain_1 = require("./YotpoReviewMain");
var YotpoWriteReview_1 = require("./YotpoWriteReview");
var YotpoSearch_1 = require("./YotpoSearch");
var yotpo_1 = require("../../utils/yotpo");
var path_1 = require("../../utils/shopify/path");
var showCTA = {
    '/pages/uro-vaginal-probiotics-reviews': {
        class: 'vp',
        url: '/collections/vaginal-health#anchor--product-title',
    },
    '/pages/meno-reviews': {
        class: 'meno',
        url: '/collections/menopause#anchor--product-title',
    },
};
var YotpoReview = function () {
    var _a;
    var _b = (0, hooks_1.useState)(null), data = _b[0], setData = _b[1];
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, yotpo_review_1.getYotpoFeaturedReviewData)(handle, pathType)
            .then(function (d) { return setData(d); })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (!data) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    // Get the review's bottom line data (including total review, avg scores,
    // and star distribution) from the review data retrieved by API. Even though this
    // data also include actual review data, it has the star distibution value that can't
    // be retrieved else where
    var _c = (0, hooks_1.useState)(null), reviewBottomlineData = _c[0], setReviewBottomlineData = _c[1];
    var _d = (0, hooks_1.useState)(null), featuredReviewsData = _d[0], setFeaturedReviewsData = _d[1];
    // Keep track of the current query request
    var _e = (0, hooks_1.useState)({
        page: 1,
    }), queryParams = _e[0], setQueryParams = _e[1];
    var _f = (0, hooks_1.useState)({
        scores: [],
    }), searchParams = _f[0], setSearchParams = _f[1];
    var _g = (0, hooks_1.useState)(null), searchReviewData = _g[0], setSearchReviewData = _g[1];
    var reviewRegex = /-reviews/gi;
    var currentPathname = window.location.pathname;
    var hasWriteReview = reviewRegex.test(currentPathname);
    // Revew search + rating filter
    var filterByScore = function (score) {
        setSearchParams(function (prev) { return (__assign(__assign({}, prev), { scores: [score] })); });
        setQueryParams({ page: 1 });
    };
    (0, hooks_1.useEffect)(function () {
        if (data.reviewIds) {
            (0, yotpo_1.getFeaturedReviewsData)(window.featuredReviewsAbTest && data.abReviewIds ? data.abReviewIds : data.reviewIds)
                .then(function (res) {
                if (res) {
                    var featuredReviews = res.map(function (searchReviewData) { return searchReviewData.review; });
                    setFeaturedReviewsData(featuredReviews);
                }
            })
                .catch(function (err) { return console.error(err); });
        }
    }, []);
    // After the initial render & query update, get review data
    (0, hooks_1.useEffect)(function () {
        (0, yotpo_1.getReviewData)(data.productId)
            .then(function (res) { return setReviewBottomlineData(res); })
            .catch(function (err) { return console.error(err); });
    }, []);
    // updated pagination to display most recently published reviews if after featured reviews
    // e.g. page 3 would still pull first page, instead of third page, of most recent published reviews if first two pages are occupied with featured 
    (0, hooks_1.useEffect)(function () {
        var queryParamsWithFeaturedReviews = (featuredReviewsData === null || featuredReviewsData === void 0 ? void 0 : featuredReviewsData.length) &&
            queryParams.page &&
            searchReviewData && {
            page: queryParams.page -
                Math.ceil(featuredReviewsData.length / searchReviewData.pagination.per_page),
        };
        setSearchReviewData(null);
        (0, yotpo_1.getSearchReviewData)(data.productId, queryParamsWithFeaturedReviews || queryParams, searchParams)
            .then(function (res) { return setSearchReviewData(res); })
            .catch(function (err) { return console.error(err); });
    }, [queryParams, searchParams]);
    if (!reviewBottomlineData || reviewBottomlineData.reviews.length == 0) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    return ((0, preact_1.h)("div", { class: "yotpo-review-section__container" },
        reviewBottomlineData && ((0, preact_1.h)(YotpoBottomline_1.default, { bottomline: reviewBottomlineData.bottomline, filterByScore: filterByScore, selected: ((_a = searchParams === null || searchParams === void 0 ? void 0 : searchParams.scores) === null || _a === void 0 ? void 0 : _a.at(0)) || 0 })),
        searchParams.scores && ((0, preact_1.h)(YotpoSearch_1.default, { searchParams: searchParams, setSearchParams: setSearchParams, setQueryParams: setQueryParams })),
        searchReviewData ? ((0, preact_1.h)(YotpoReviewMain_1.default, { featuredReviewsData: featuredReviewsData, searchReviewData: searchReviewData, queryParams: queryParams, searchParams: searchParams, setQueryParams: setQueryParams })) : ((0, preact_1.h)(Loading_1.default, null)),
        hasWriteReview && ((0, preact_1.h)(YotpoWriteReview_1.default, { productId: data.productId, shareReviewText: 'Share your thoughts with other customers', shareReviewButtonText: 'Write a review' })),
        window.location.pathname in showCTA && ((0, preact_1.h)("div", { class: "easy-review-ab__sticky-button-container" },
            (0, preact_1.h)("a", { class: "easy-review-ab__sticky-button easy-review-ab__sticky-button--".concat(showCTA[window.location.pathname].class), href: "".concat(showCTA[window.location.pathname].url) },
                ' ',
                "SHOP NOW",
                ' ')))));
};
exports.default = YotpoReview;
